"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtuPerCubicFeet = exports.KiloJoulePerCubicMeter = exports.KiloWattHourPerCubicMeter = void 0;
var UnitDivide = require("../unit-divide");
var energy_1 = require("./energy");
var energy2_1 = require("./energy2");
var volume_1 = require("./volume");
// Energy per volume
exports.KiloWattHourPerCubicMeter = UnitDivide.energyByVolume("KiloWattHourPerCubicMeter", energy2_1.KiloWattHour, volume_1.CubicMeter);
exports.KiloJoulePerCubicMeter = UnitDivide.energyByVolume("KiloJoulePerCubicMeter", energy_1.Kilojoule, volume_1.CubicMeter);
exports.BtuPerCubicFeet = UnitDivide.energyByVolume("BtuPerCubicFeet", energy_1.Btu, volume_1.CubicFeet);
//# sourceMappingURL=heating-value.js.map